<p-menubar class="menuStyle mb-1" [model]="items">
  <ng-template pTemplate="start">
    <img
      (click)="gotoDashboard()"
      class="clickable"
      class="logo_style_header"
    />
  </ng-template>
  <ng-template pTemplate="end">
    <div class="flex-row zoom_class">
      <div class="flex-row me-2 ms-1">
        <div class="flex-row text-right notification-container">
          <div class="notification-badge-container">
          </div>
        </div>
      </div>
      <div class="col-9 profile_ouline" [class.mr-5]="showAvatar">
        <button
          pButton
          class="p-button-outlined"
          type="button"
          id="dropdownMenuButton1"
          data-bs-toggle="dropdown"
          aria-expanded="false"
          style="height: 3rem"
        >
          <i
            *ngIf="!showAvatar"
            class="pi pi-angle-down"
            style="font-size: 1rem"
          ></i>
          <span *ngIf="!showAvatar" class="font_text">{{
            userName.length > 12 ? userName.slice(0, 12) + "..." : userName
          }}</span>
          <p-avatar
            label="{{ userName[0] }}"
            styleClass="mr-2"
            [style]="{ 'background-color': themeColor, color: '#ffffff' }"
            shape="circle"
          ></p-avatar>
        </button>
        <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
          <li (click)="navigateTo('profile/form')">
            <span
              class="dropdown-item"
              style="font-size: 0.9rem; cursor: pointer"
            >
              Profile
            </span>
          </li>
          <li (click)="navigateTo('razorpay/transaction-details')">
            <span
              class="dropdown-item"
              style="font-size: 0.9rem; cursor: pointer"
            >
              Payment History
            </span>
          </li>

           <li *ngIf="is_wallet" (click)="navigateTo('wallet/transaction-details')">
            <span
              class="dropdown-item"
              style="font-size: 0.9rem; cursor: pointer"
            >
             Wallet History
            </span>
          </li>

          <li (click)="navigateTo('profile/settings')">
            <span
              class="dropdown-item"
              style="font-size: 0.9rem; cursor: pointer"
            >
              Settings
            </span>
          </li>
          <li>
            <a
              class="dropdown-item"
              style="font-size: 0.9rem; cursor: pointer"
              (click)="logout()"
              >Log out <i class="bx bx-exit"></i
            ></a>
          </li>
        </ul>
      </div>
    </div>
  </ng-template>
</p-menubar>
 
<p-drawer [(visible)]="visibleSidebar2" position="right">
  <div class="row">
    <div class="col-lg-5 col-sm-5 col-md-5">
      <span class="title_five">Notifications</span>
    </div>
    <div class="col-lg-7 col-sm-7 col-md-7 text-right">
      <span class="side_nav_mark"
        >Mark as read
        <i
          class="clickable ms-2 pi pi-check-circle"
          (click)="setAllMarkAsRead()"
          style="font-size: 0.6rem"
        ></i
      ></span>
    </div>
  </div>
 
  <p-accordion [multiple]="false">
    <p-accordion-panel
      *ngFor="let notification of notificatioData; let i = index"
      [value]="i"
      class="my-1"
      [ngClass]="notification.is_read ? '' : 'notifi-background'"
    >
      <p-accordion-header (click)="setActive(i); markAsRead(notification.id, notification.is_read)">
        {{ notification.title }}
      </p-accordion-header>
      <p-accordion-content>
        <p>{{ notification.description }}</p>
      </p-accordion-content>
    </p-accordion-panel>
  </p-accordion>
</p-drawer>
 
<div
  class="col-lg-3 col-sm-3 col-md-3 overlay_1 cat-execution-dropdown"
  *ngIf="showSelectBranch"
>
  <app-dropdown
    placeholder="Select Branch"
    [options]="branchData"
    [(ngModel)]="selectedBranch"
    (click)="onBranchChange()"
    optionLabel="name"
  ></app-dropdown>
</div>
 